'use strict';

exports.__esModule = true;
exports.widget = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _widgetActions = require('../actions/widget-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {};

var widget = exports.widget = function widget(state, action) {
    switch (action.type) {
        case _widgetActions.GET_PROFILE_DETAILS:
            return (0, _extends3.default)({}, state, action.payload);
        case _widgetActions.GET_LAYOUT_TYPE:
            return (0, _extends3.default)({}, state, action.payload);
        case _widgetActions.LOAD_REVIEWS + '_RECEIVED':
            return (0, _extends3.default)({}, state, {
                reviews: action.response.reviews
            });
        case _widgetActions.LOAD_REVIEWS_STAT + '_RECEIVED':
            return (0, _extends3.default)({}, state, action.response);
        default:
            return state || INITIAL_STATE;
    }
};